import {
    PieChart,
    Pie,
    Tooltip,
    Cell,
    Legend,
    ResponsiveContainer
} from 'recharts';
import { Box, Typography } from '@mui/material';
import { FertilizerLegend, PieTooltip, fertilizerPieChartLabel } from '../utils/graph-utils';
import { agrochemicalsColors, legendHeight, legendIconSize, outerRadius, responsiveContainerHeight, agrochemicalsLegendItems } from '../constants/graph-constants';

/**
 * 
 * @param {Object} props 
 * @param {{category: string, total: number, type: string}} props.data Graph data from backend
 * @param {string} props.type
 * @param {string} props.group "Twee Jonge Gezellen"
 * @param {string} props.year "2024"
 * @param {string} props.unit The relevant unit.
 * @returns {JSX.Element} The facility's bar graph which displays an array of fertilizer items
 */
export default function AgrochemicalsFacilityPieChart({ data, group, type, year, unit }) {
    return (
        <Box sx={{ width: '100%', height: '100%' }}>
            <Typography variant="h6" align="center" gutterBottom>
                {group} {year} Annual {type} Facility Split
            </Typography>
            <ResponsiveContainer width="100%" height={responsiveContainerHeight}>
                <PieChart>
                    <Tooltip content={<PieTooltip unit={unit} />} />
                    <Legend content={<FertilizerLegend legendItems={agrochemicalsLegendItems} />} iconSize={legendIconSize} verticalAlign='top' height={legendHeight} />
                    <Pie
                        data={data}
                        dataKey="total"
                        nameKey="category"
                        cx="50%"
                        cy="50%"
                        outerRadius={outerRadius}
                        labelLine={false}
                        label={fertilizerPieChartLabel}
                    >
                        {data?.map((entry, index) => (
                            <Cell key={index}
                                fill={agrochemicalsColors[entry.category] || '#ccc'}
                            />
                        ))}
                    </Pie>
                </PieChart>
            </ResponsiveContainer>
        </Box>
    )
}